module.exports = __webpack_public_path__ + "img/added-services-add.87808722.svg";